<template>
	<div>
		<v-card
			elevation="1"
			transition="scale-transition"
			origin="center center"
			:color="getColorDataForState(buttonColour).color"
			class="justify-center text-center mx-auto"
			height="100"
			width="100"
			style="border-radius: 8px !important"
			@click="onTriggerForm()"
		>
			<v-row>
				<v-img :src="getImageForState(buttonColour)" :width="image_width" :height="image_height" contain class="mt-2 pt-2 mx-auto"></v-img>
				<v-card-text
					class="pt-2 ml-1 mr-1 justify-center text-center"
					style="
						font-family: Montserrat;
						font-style: normal;
						font-weight: 500;
						font-size: 15px;
						line-height: 13px;
						display: flex;
						align-items: center;
						text-align: center;
					"
				>
					<p :style="{ color: getColorDataForState(buttonColour).text_color }">{{ text }}</p>
				</v-card-text>
			</v-row>
		</v-card>
	</div>
</template>

<script>
import { bus } from '@/main';

export default {
	components: {
		// VBadge
	},
	props: {
		form: {},
		context: {
			type: String,
		},
		image_o: {
			type: String,
		},
		image_g: {
			type: String,
		},
		image_w: {
			type: String,
		},
		text: {
			type: String,
		},
		image_width: {
			type: Number,
			default: 45,
		},
		image_height: {
			type: Number,
			default: 45,
		},
		buttonColour: {
			type: String,
			default: 'negative',
		},
	},
	data: () => ({
		name: 'ProfileStepButton',
	}),
	computed: {},

	created() {},

	mounted() {},
	beforeDestroy() {
		bus.$off('intent:submit-forms');
	},
	methods: {
		getColorDataForState(n) {
			if (n == 'positive') {
				return {
					color: 'rgba(99, 195, 103, 0.2)',
					text_color: 'rgba(99, 195, 103, 1)',
				};
			} else if (n == 'busy') {
				return {
					color: '#FFF2E8',
					text_color: 'rgba(252, 126, 30, 0.5)',
				};
			} else if (n == 'negative') {
				return {
					color: 'primary',
					text_color: '#FFFFFF',
				};
			}
		},
		getBadgeDataForState(n) {
			if (n == 'positive') {
				return {
					show: true,
					color: '#63C367',
					icon: 'done', //check_circle?
				};
			} else if (n == 'busy') {
				return {
					show: true,
					color: 'primary',
					icon: 'access_time',
				};
			} else if (n == 'negative') {
				return {
					show: false,
				};
			}
		},
		getImageForState(n) {
			if (n == 'positive') {
				return this.image_g;
			} else if (n == 'busy') {
				return this.image_o;
			} else if (n == 'negative') {
				return this.image_w;
			}
		},

		onTriggerForm() {
			if (this.form) {
				bus.$emit('intent:change-context', this.context);
			}
		},
	},
};
</script>
